import styled from 'styled-components';

import { CloseOutlined } from '@ant-design/icons';

import InfoIcon from '/public/assets/icons/info-icon.svg';

import { sizeUp } from '~/theme';

/* ── Shared banner bar ── */

export const BannerStatusBar = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',

  width: '100%',
  position: 'absolute',
  insetBlockEnd: '-45rem',
  insetInlineStart: '0',

  color: 'white',
  fontSize: theme.typography.size14,
}));

export const BannerBar = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',

  position: 'relative',

  backgroundColor: theme.palette.lavenderBlush,

  paddingBlock: '30rem',

  '&[data-type="outage"]': {
    maxHeight: '160rem',
    maxWidth: '920rem',

    borderRadius: '20rem',
    paddingInline: sizeUp('20rem', ['md', '30rem']),
  },

  '&[data-type="warning"]': {
    maxHeight: '119rem',

    borderBlockStart: `${theme.palette.tuttiFruitti} 6rem solid`,
    paddingInlineStart: sizeUp('50rem', ['md', '112rem']),
    paddingInlineEnd: sizeUp('20rem', ['md', '60rem']),
  },
}));

export const Content = styled.div({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,

  position: 'relative',
});

export const TitleRow = styled.div({
  position: 'relative',

  '[data-type="warning"] &': {
    marginBlockEnd: '14rem',
  },

  '[data-type="outage"] &': {
    marginBlockEnd: '20rem',
  },
});

export const DescriptionRow = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: '20rem',

  '[data-type="outage"] &': {
    justifyContent: 'center',
  },
});

const redInfoIconSize = sizeUp('20rem', ['md', '24rem']);

export const RedInfoIcon = styled(InfoIcon)(({ theme }) => ({
  fill: theme.palette.tuttiFruitti,

  width: redInfoIconSize,
  height: redInfoIconSize,

  position: 'absolute',
  insetBlockStart: '50%',
  transform: 'translateY(-50%)',
  insetInlineStart: `calc((${redInfoIconSize} * -1) - ${sizeUp('10rem', ['md', '26rem'])})`,
}));

export const BlackInfoIcon = styled(InfoIcon)(() => ({
  fill: 'black',

  width: '48rem',
  height: '48rem',

  alignSelf: 'center',
}));

export const TitleText = styled.span(({ theme }) => ({
  fontFamily: theme.typography.family.arial,
  fontWeight: 'bold',
  color: 'black',

  marginBlockEnd: '14rem',

  '[data-type="warning"] &': {
    fontSize: sizeUp(theme.typography.size16, ['md', theme.typography.size18]),
  },

  '[data-type="outage"] &': {
    fontSize: sizeUp(theme.typography.size18, ['md', theme.typography.size24]),
  },
}));

export const Description = styled.div(({ theme }) => ({
  fontFamily: theme.typography.family.arial,
  fontWeight: 'normal',
  color: 'black',
  marginBlockStart: '4rem',

  '[data-type="warning"] &': {
    fontSize: sizeUp(theme.typography.size14, ['md', theme.typography.size16]),
  },

  '[data-type="outage"] &': {
    fontSize: sizeUp(theme.typography.size16, ['md', theme.typography.size18]),
  },
}));

/* ── Warning close button ── */

const btnIconSize = sizeUp('16rem', ['md', '20rem']);

export const CloseIcon = styled(CloseOutlined)({
  '& svg': {
    width: btnIconSize,
    height: btnIconSize,
  },
});

export const CloseButton = styled.button({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  alignSelf: 'center',

  width: btnIconSize,
  height: btnIconSize,
  marginInlineStart: '45rem',

  background: 'transparent',
  border: 'none',
  cursor: 'pointer',
  color: 'black',
});

/* ── Outage full-page blocker ── */

export const Overlay = styled.div(({ theme }) => ({
  position: 'fixed',
  inset: 0,
  zIndex: theme.overlayPosition.layerImportant + 1,

  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',

  backgroundColor: 'rgba(0, 0, 0, 0.80)',
}));

export const SageIconWrapper = styled.div(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10rem',
}));
